import { useEffect, useState } from 'react';
import { AutoMovement } from '../../../../types';
import { useLeads } from '../../../../contexts/leads/LeadsContext';
import type { WhatsAppConnectionOption } from './useWhatsAppConnections';

type UseAutoMovementFormPanelParams = {
    isOpen: boolean;
    movementToEdit?: AutoMovement;
    whatsappConnections: WhatsAppConnectionOption[];
    onSave: (data: Omit<AutoMovement, 'id' | 'createdAt' | 'organizationId'>) => void;
};

export function useAutoMovementFormPanel({
    isOpen,
    movementToEdit,
    whatsappConnections,
    onSave,
}: UseAutoMovementFormPanelParams) {
    const { funnelStages } = useLeads();

    const [message, setMessage] = useState('');
    const [mode, setMode] = useState<AutoMovement['mode']>('contains');
    const [channelId, setChannelId] = useState('');
    const [stageId, setStageId] = useState('');

    useEffect(() => {
        if (!isOpen) return;

        if (movementToEdit) {
            setMessage(movementToEdit.message);
            setMode(movementToEdit.mode);
            setChannelId(movementToEdit.channelId);
            setStageId(movementToEdit.stageId);
            return;
        }

        setMessage('');
        setMode('contains');
        setChannelId('');
        setStageId('');
    }, [isOpen, movementToEdit]);

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();

        const selectedStage = funnelStages.find((stage) => stage.id === stageId);
        const selectedChannel = whatsappConnections.find((connection) => connection.id === channelId);

        onSave({
            message,
            mode,
            channelId,
            channelName: selectedChannel
                ? (selectedChannel.phone_number || selectedChannel.instance_name)
                : 'Todos os canais',
            stageId,
            stageName: selectedStage?.name || '',
        });
    };

    return {
        message,
        setMessage,
        mode,
        setMode,
        channelId,
        setChannelId,
        stageId,
        setStageId,
        funnelStages,
        handleSubmit,
    };
}
